import axios from 'axios'

export const url = "http://ghbazargan.com/api/v1"
export const baseurl = "http://ghbazargan.com"






export const getSansinfobyID = (concertID) => {
    let formdata = new FormData()
    formdata.append('concert_id', concertID)
    return axios.post(`${url}/sans`, formdata)

}









// ---------------------------- Safiran---------------------------
export const getSplash = ( ) => {
    return axios.get(`${url}/splash`)
}

export const getBlogs = (config ) => {
    return axios.get(`${url}/news`,config)
}
export const getBlog = (config ) => {
    return axios.get(`${url}/new`,config)
}








